<script setup lang="ts">
import type { Ref } from 'vue'
import {
  getWorkspacePermission,
  guard,
  type Permission,
  type WorkspacePermission,
} from '../utils/permissions'

const props = withDefaults(
  defineProps<{
    permissions?: Permission[]
    workspacePermissions?: WorkspacePermission[]
    workspaceId?: string
  }>(),
  {
    permissions: () => [],
    workspacePermissions: () => [],
    workspaceId: '',
  },
)

const injectedPermissions = inject<Ref<string[]> | undefined>(
  'user-permissions',
  undefined,
)

const userPermissions = computed(() => injectedPermissions?.value || [])

const combinedPermissions = computed((): string[] => [
  ...props.permissions,
  ...(props.workspaceId
    ? props.workspacePermissions.map((permission) =>
        getWorkspacePermission(props.workspaceId, permission),
      )
    : []),
])

const passGuard = computed(() =>
  guard('ANY', combinedPermissions.value, userPermissions.value),
)
</script>

<template>
  <slot v-if="passGuard" v-bind="{ combinedPermissions, userPermissions }" />
  <slot v-else v-bind="{ userPermissions }" name="fallback" />
</template>
